import React from 'react';
import { isEmpty } from 'lodash';
import { Text } from 'Components/frameworks/text/Text';
import { Title } from 'Components/frameworks/title/Title';
export type ProductFeatureDetailFacilityProps = {
  className?: string;
  description?: string;
  id?: string;
  items?: Array<{
    description: string;
    label?: string;
  }>;
  quantity?: number;
  title: string;
};
export function ProductFeatureDetailFacility(props: ProductFeatureDetailFacilityProps) {
  const { className, id, items = [], description, quantity, title } = props;

  if (!title) {
    return null;
  }

  return (
    <article className={className} id={id}>
      <Title hLevel={5} theme="title-sans-n2">
        {title}
        {!!quantity && `: ${quantity}`}
      </Title>
      <Text className="m-0 text-darkGrey" text={description} theme="text-sans-n2" />
      {!isEmpty(items) && (
        <ul className="mt-10 list-none p-0 font-sans text-12 text-black">
          {items.map((item) => {
            return (
              !!item.description && (
                <li className="list-disc" key={item.description}>
                  {item.label && <span className="font-bold">{item.label}: </span>}
                  {item.description}
                </li>
              )
            );
          })}
        </ul>
      )}
    </article>
  );
}
